import { useSelector } from 'react-redux'
import { Item, selectNewTodos } from '../features/TodoSlice'
import TodoItem from './TodoItem'

const UndoneTodos = () => {
    const undoneTodos = useSelector(selectNewTodos)
    
    return (
        <div data-testid="todo_list_new" className='undone_block'>
            <h3 className='undone_block__title'>New Tasks</h3>
            {
                undoneTodos.map((todo: Item) => 
                    <TodoItem 
                        key={todo.id}
                        id={todo.id}
                        title={todo.title}
                        description={todo.description}
                        deadline={todo.deadline}
                        status={todo.status}
                    />)
            }
            
        </div>
    )
}

export default UndoneTodos